import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../common/customHttp.service';
import { ApiUrl } from '../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../layout/layout.component';
import { PageResultDto, ShipSearchFields } from '../../common/viewModels/GlobalRegistry/UnitsModel';
import { ToastrService } from 'ngx-toastr';
import { PagerService } from '../../common/pagerService';
declare var $: any;

@Component({
  selector: 'ship',
  templateUrl: './ship.component.html',
  styleUrls: ['./ship.component.scss']
})
export class ShipComponent implements OnInit {
  shipForm: FormGroup;
  shipSearchForm: FormGroup;
  id: number;
  searchFields: ShipSearchFields = new ShipSearchFields();
  isNoRecords: boolean = true;
  isSubmitted: boolean = false;
  pager: any = {};
  pagedItems: any[];
  pageResult: PageResultDto;
  length: number = 0;
  mainComponent: any;
  //pager:Pager=new Pager();
  $element: any;
  $content: any;

  constructor(public _router: Router, private _formBuilder: FormBuilder, private _pagerService: PagerService,
    private _http: CustomHttp,
    private _appUrl: ApiUrl, private _route: ActivatedRoute,
    private _mApp: MainAppComponent, private _toastrService: ToastrService) {
    this.mainComponent = _mApp;
  }

  ngOnInit() {
    this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
    this.pager.pageIndex = 0;
    this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
    this.CreateForm();
    this.shipSearchForm = this._formBuilder.group({
      Name: [''],
      ShipId: [0],
    });
    this.BindStaticSearchData();
    this.setPage(this.pager); 
  }

  CreateForm() {
    this.shipForm = this._formBuilder.group({
      ShipId: [0],
      Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(500)])],
    });
  }

  BindStaticSearchData() {
    this.searchFields.PageNo = 0;
    this.searchFields.PageSize = this._pagerService.pageSize;
  }

  setPage(page: any) {
    this.pager.pageSize = page.pageSize;
    this.pager.pageIndex = page.pageIndex;
    this.GetShipsList(this.pager);
  }

  GetShipsList(page: any) {
    this.searchFields.PageNo = page.pageIndex;
    this.searchFields.PageSize = page.pageSize
    this._mApp.ShowLoader();
    this._http.post(this._appUrl.GetShipList, this.searchFields)
      .subscribe(
      res => {
        var data = res.json();
        this.length = data.PageResult.TotalRecords;
        this.pagedItems = data.Result;
        this.isNoRecords = !(data.Result.length > 0);
        this._mApp.HideLoader();
      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  GetShipsById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetShipById + id)
      .subscribe(
      m => {
        this._mApp.HideLoader();
        if (m.json().Result != null) {
          this.shipForm.setValue(m.json().Result);
        }
      }, error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      )
  }

  DeleteShip(id: any) {
    this.id = id;
  }

  DeleteShipById(id: number) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.DeleteShip + id)
      .subscribe(
      res => {
        this._mApp.HideLoader();
        this.setPage(this.pager);
        this._toastrService.success(res.json().Result, '');

      },
      error => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result, '');
      }
      );
  }

  onSearchSubmit() {
    this.pager.pageIndex = 0;
    let searchDto = this.shipSearchForm.value;
    if (searchDto.Name != null)
      this.searchFields.Name = searchDto.Name;
    this.setPage(this.pager);
  }

  onSubmit() {
      
    this.shipForm.get('Name').setValidators(Validators.compose([ Validators.required, Validators.minLength(1), Validators.maxLength(500)]));
    this.shipForm.get('Name').updateValueAndValidity();
    this.isSubmitted = true;
    if (this.shipForm.valid) {
      let shipDto = this.shipForm.value;
      this._mApp.ShowLoader();
      if(shipDto.ShipId==null||shipDto.ShipId==0)
      {
        shipDto.ShipId=0;
      }
      this._http.post(this._appUrl.UpsertShip, shipDto)
        .subscribe(
        data => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, '');
          $('#addShipModel').modal('toggle');
          this.Clear();
          this.setPage(this.pager);
        },
        error => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, '');
        }
        );
    }
    else {
      
    }
  }

  Clear() {
    this.shipForm.get('Name').setValidators(Validators.compose([ Validators.minLength(1), Validators.maxLength(500)]));
    this.shipForm.get('Name').updateValueAndValidity();
    this.shipForm.reset();  
  } 

  OnReset() {
    this.shipSearchForm.reset();
    this.pager.pageSize = this._mApp.pageSize;
    this.pager.pageIndex = 0;
    this.searchFields.Name = '';
    this.setPage(this.pager);
  }
  
}
